import { render, staticRenderFns } from "./LicenseContent.vue?vue&type=template&id=631a9660&scoped=true&"
import script from "./LicenseContent.vue?vue&type=script&lang=js&"
export * from "./LicenseContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631a9660",
  null
  
)

export default component.exports